import { resolveWrongImage, wrongTextWithoutImage } from '../utils/adminWrongQuestions';

export default function AdminWrongText({ text }: { text: string }) {
  const image = resolveWrongImage(text);
  return <span className="whitespace-pre-line">
    {image ? wrongTextWithoutImage(text) : text}
    {image && <img src={image} alt="Question image" className="mt-2 max-h-64 max-w-full object-contain" />}
  </span>;
}
